import { dev_baseUrl } from "utils/var";
import { getToken } from "utils/auth";

export const ValidateInviteToken = async (token) => {
  if (!token) {
    return { isError: true, message: "Token is required." };
  }

  try {
    const response = await fetch(`${dev_baseUrl}/Account/validateInviteToken?token=${token}`, {
      method: "GET",
    });

    const data = await response.json();

    if (!response.ok || data.isError) {
      return { isError: true, message: data.message || "Token validation failed." };
    }

    return data;
  } catch (error) {
    console.error("Error validating invite token:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};

export const CompleteInvitation = async (payload) => {
  if (!payload?.token || !payload?.password) {
    return { isError: true, message: "Token and password are required." };
  }

  try {
    const response = await fetch(`${dev_baseUrl}/Account/completeInvitation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json();

    if (!response.ok || data.isError) {
      return { isError: true, message: data.message || "Failed to complete invitation." };
    }

    return data;
  } catch (error) {
    console.error("Error completing invitation:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};

export const SendInvite = async (EmployeeID) => {
  if (!EmployeeID && EmployeeID > 0) {
    return { isError: true, message: "Missing required invite details." };
  }
  const accesstoken = getToken();
  try {
    const response = await fetch(`${dev_baseUrl}/Account/sendInvite?EmployeeID=${EmployeeID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accesstoken}`,
      },      
    });

    const data = await response.json();

    if (!response.ok || data.isError) {
      return { isError: true, message: data.message || "Failed to send invitation." };
    }

    return data;

  } catch (error) {
    console.error("Error sending invitation:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};

export const GetPortalStatuses = async (EmployeeID) => {
  if (!EmployeeID && EmployeeID > 0) {
    return { isError: true, message: "Missing required invite details." };
  }
  const accesstoken = getToken();
  try {
    const res = await fetch(`${dev_baseUrl}/Account/getPortalStatus?employeeID=${EmployeeID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accesstoken}`,
      },      
    });

    const data = await res.json();
    console.log(data)
  
    if (!res.ok || data.isError) {
      throw new Error(data.message || "Error getting portal statuses");
    }
    
    return data?.result || [];
    
  } catch (error) {
    console.error("Error getting portal statuses:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};

export const DeactivatePortal = async (EmployeeID) => {
  if (!EmployeeID && EmployeeID > 0) {
    return { isError: true, message: "Missing required details." };
  }
  const accesstoken = getToken();
  try {
    const res = await fetch(`${dev_baseUrl}/Account/deactivatePortal?employeeID=${EmployeeID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accesstoken}`,
      },      
    });

    const data = await res.json();
  
    if (!res.ok || data.isError) {
      throw new Error(data.message || "Error deactivating Portal");
    }
    
    return data;
    
  } catch (error) {
    console.error("Error deactivating Portal:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};

export const ReactivatePortal = async (EmployeeID) => {
  if (!EmployeeID && EmployeeID > 0) {
    return { isError: true, message: "Missing required details." };
  }
  const accesstoken = getToken();
  try {
    const res = await fetch(`${dev_baseUrl}/Account/reactivatePortal?employeeID=${EmployeeID}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accesstoken}`,
      },      
    });

    const data = await res.json();
  
    if (!res.ok || data.isError) {
      throw new Error(data.message || "Error reactivating Portal");
    }
    
    return data;
    
  } catch (error) {
    console.error("Error reactivating Portal:", error);
    return { isError: true, message: "An error occurred. Please try again later." };
  }
};
